@let items = breadcrumb.items$ | async;
@if (items && items.length > 0) {
  <nav class="breadcrumb-bar" aria-label="breadcrumb">
    <ol class="breadcrumb">
      @for (item of items; track $index; let last = $last) {
        <li class="breadcrumb-item">
          @if (item.url && !last) {
            <a [routerLink]="item.url">{{ item.text }}</a>
          } @else {
            <span [class.current]="last">{{ item.text }}</span>
          }
          @if (!last) {
            <span class="separator" aria-hidden="true">&rsaquo;</span>
          }
        </li>
      }
    </ol>
  </nav>
}
